export default function Popper(containerId: string) {
  return {
    MuiPopper: {
      defaultProps: {
        disablePortal: false,
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        root: {
          maxWidth: '100vw',
        },
      },
    },
  };
}
